import React, { useState, useContext } from "react";
import { TextField, Typography } from "@mui/material";

import { LoadingButton } from "@mui/lab";
import { httpService, projectAccount } from "../httpService";
import { AlertContext } from "../contexts/AlertContext";
import logo from "../pages/logo.png";

export default function LoginPage() {
  const { setAlertData } = useContext(AlertContext);
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState({});
  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { data, error } = await httpService.post("login", user);
    if (data) {
      localStorage.setItem(projectAccount, data);
      window.location.assign("/");
    }
    if (error) {
      setAlertData({
        open: true,
        severity: "error",
        horizontal: "center",
        message: error,
      });
    }
    setLoading(false);
  };
  return (
    <div>
      <div className="mt-5 mb-5 container">
        <div className="row">
          <div className="col-lg-6 loginBanner  p-4 d-none d-lg-block">
            <div className="text-center">
              <img src={logo} height={60} width={70} alt="Jamb Logo" />
            </div>
            <div className="mt-4 text-center">
              <Typography variant="h4" fontWeight={700} color="GrayText">
                JAMB {new Date().getFullYear()} POLICY MEETING STAFF LOGIN{" "}
              </Typography>
            </div>
            <div className="mt-2">
              <Typography fontWeight={700} fontStyle="italic">
                Authorized for staff only
              </Typography>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="d-sm-block d-lg-none">
              <div className="text-center">
                <img src={logo} height={60} width={70} alt="Jamb Logo" />
              </div>
              <div className="mt-3 mb-3 text-center">
                <Typography variant="h5" fontWeight={700} color="GrayText">
                  JAMB {new Date().getFullYear()} POLICY MEETING STAFF LOGIN{" "}
                </Typography>
              </div>
              <div className="mt-2 text-center mb-3">
                <Typography fontWeight={700} fontStyle="italic">
                  Authorized for staff only
                </Typography>
              </div>
            </div>
            <div>
              <form>
                <div className="mb-4">
                  <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    name="email"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-4">
                  <TextField
                    fullWidth
                    label="Password"
                    type="password"
                    name="password"
                    onChange={handleChange}
                  />
                </div>
                <LoadingButton
                  onClick={handleSubmit}
                  variant="contained"
                  fullWidth
                  type="submit"
                  loading={loading}
                >
                  Login
                </LoadingButton>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
